import { ListItemAvatar, ListItemSecondaryAction } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Delete, MoreHoriz, Person } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Link } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom'

import { Collections } from 'Collections';
import { useAppUser } from 'components/AppUserProvider';
import { FullscreenLoading } from 'components/FullscreenLoading';
import { useOrgUser } from 'components/OrgUserProvider';
import { PageNavigation } from 'components/PageNavigation';
import { FirebaseUtils } from 'firebaseUtils/FirebaseUtils';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { HelpChat } from 'models/HelpChat';
import { Paths } from 'Paths';

import { MenuButton } from './ListScreen';

export function dateString(date: Date, separator: string = '.'): string {
    return [date.getDate(), date.getMonth(), date.getFullYear()].join(separator);
}

export function HelpChats() {
    const { enqueueSnackbar } = useSnackbar()
    const [orgUserDoc, loadingOrgUser] = useOrgUser()
    const [appUserDoc, loadingAppUser] = useAppUser()

    const orgUser = orgUserDoc?.data || null
    const appUser = appUserDoc?.data || null

    const [chats, loadingChats] = FirebaseUtils.useCollectionData<HelpChat>(
        true,
        Collections.HELP_CHATS,
        AnalyticsEvent.GET_HELP_CHATS_ERROR,
        {},
        (query, path) => (
            query.orderBy(path.metadata.createdAt, 'asc')
        ))

    const loading = loadingChats || loadingOrgUser || loadingAppUser

    const content = loading ? <FullscreenLoading screenId="Help" /> : (
        <List>
            {chats?.map((chat) => {
                return (
                    <ListItem
                        key={chat.data.id}
                        component={Link}
                        to={Paths.HELP_MESSAGES + '/' + chat.data.appUser.id}
                    >
                        <ListItemAvatar>
                            <Avatar
                                component={RouterLink}
                                to={Paths.APP_USERS + '/' + chat.data.appUser.id}
                                src={chat.data.appUser.avatarImage?.original.url || undefined}>
                                <Person />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={chat.data.appUser.contactInfo?.name?.fullName}
                            secondary={chat.data.appUser.contactInfo?.email?.email}
                        />
                        <ListItemSecondaryAction>
                            <MenuButton
                                label="Alternativer"
                                icon={<MoreHoriz />}

                                options={[
                                    (!appUser) ? null : ["Slett", <Delete />, () => {
                                        FirebaseUtils.deleteDocument(
                                            true,
                                            Collections.HELP_CHATS,
                                            chat.data.id,
                                            appUser,
                                            orgUser,
                                            AnalyticsEvent.DELETED_HELP_CHAT,
                                            AnalyticsEvent.DELETED_HELP_CHAT,
                                            AnalyticsEvent.DELETE_HELP_CHAT_ERROR,
                                            enqueueSnackbar,
                                            'Slettet chatten',
                                        )
                                    }]
                                ]}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                )
            })}
            {chats?.length ? null : (
                <ListItem>
                    <ListItemText
                        primary="Ingen chatter har blitt åpnet enda"
                    />
                </ListItem>
            )}
        </List>
    )

    return (
        <PageNavigation backHistoryButton title="Hjelp">
            {content}
        </PageNavigation>
    )
}
